document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function afterUpdate() {
    if (mz._initProductItems) {
      mz._initProductItems()
      mz.rimg_shopify_dist_index_es.init('[data-rimg="lazy"]', {
        round: 1,
      })
      $('.mz-skeleton-wrapper').addClass('hidden')
    }
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
